import React from 'react';
import './btnPrimary.css'
const BtnPrimary = ({ value,styleClass }) => {
    return (
        <>
            <button className={styleClass}>{value}</button>
        </>
    );
}

export default BtnPrimary;
